module.exports = __webpack_public_path__ + "b4a9cfaa285ad0c8dd981ec374dc37c2.png";